import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Close extends PureComponent {
  render () {
    return (
      <button type='button' onClick={this.props.onClick} className={`button-close ${this.props.className || ''}`} />
    );
  }
}

Close.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/common/ui/Close.js